import * as React from 'react';

import type {
    GetQuoteById_quote_subtotalLineItems as SubtotalLineItems,
    GetQuoteById_quote_subtotal as Money,
    GetQuoteById_quote_total as TotalMoney,
} from 'nutshell-graphql-types';

import {Button} from '../../button/button';
import {Body} from '../../typography/body';

import styles from '../quote.module.css';

type Props = {
    subtotal: Money;
    subtotalLineItems: SubtotalLineItems;
    total: TotalMoney;
    onAddRow: () => void;
    onToggleActive: (sectionName: string) => void;
    sectionName: string;
};

export function QuoteSubtotal(props: Props) {
    const handleAddRowClick = (e: Event) => {
        e.stopPropagation();
        props.onAddRow();
        props.onToggleActive(props.sectionName);
    };

    return (
        <div className='full-height full-width br-3'>
            <div className={styles['subtotal-container']}>
                <div className='flex justify-sb'>
                    <Body color='dark'>Subtotal</Body>
                    <Body isBold={true}>{props.subtotal.formattedWithCents}</Body>
                </div>
                {props.subtotalLineItems.edges.map(({node}) => (
                    <div key={node.id} className='flex justify-sb gap-32'>
                        <div className={styles['subtotal-row-label']}>
                            <Body color='dark'>{node.label}</Body>
                        </div>
                        {node.modifierUnit === 'PERCENT' && (
                            <div className={styles['subtotal-row-percent']}>
                                <Body color='dark'>{node.modifierValue}%</Body>
                            </div>
                        )}
                        <div className={styles['subtotal-row-price']}>
                            <Body isBold={true}>{node.price.formattedWithCents}</Body>
                        </div>
                    </div>
                ))}
                <div className={styles['add-row-button']}>
                    <Button
                        // @ts-expect-error
                        onClick={handleAddRowClick}
                        variant='text-primary'
                        size='xlarge'
                        noPadding={true}
                    >
                        + Add a discount, fee, or tax
                    </Button>
                </div>
            </div>
            <div className={styles['total-container']}>
                <Body isBold={true} size='large'>
                    Total
                </Body>
                <Body isBold={true} size='large'>
                    {props.total.formattedWithCents}
                </Body>
            </div>
        </div>
    );
}
